import jwt_decode from "jwt-decode";
import { Token } from "./getAuthorization";

export function getScopesFromToken(token: string) {
  try {
    return jwt_decode<Token>(token)?.scope;
  } catch {
    return [];
  }
}
